import { Component } from '@angular/core';
import { FooterComponent } from '../../shared/footer/footer.component';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  constructor(private titleService: Title, private meta: Meta,) {

    const title = 'Privacy Policy - Softnet Computers'
    const des = 'Upgrade your tech at Softnet Computers, Sri Lanka\'s top store in Negombo! Gaming laptops, business PCs, used desktops & more. Call Now: 077 (255) 3478. Trusted warranty & support'

    try {
      this.meta.removeTag('title');
      this.meta.removeTag('description');

      this.meta.removeTag('og:type');
      this.meta.removeTag('og:url');
      this.meta.removeTag('og:title');
      this.meta.removeTag('og:description');
      this.meta.removeTag('og:image');


      this.meta.removeTag('twitter:card');
      this.meta.removeTag('twitter:url');
      this.meta.removeTag('twitter:title');
      this.meta.removeTag('twitter:description');
      this.meta.removeTag('twitter:image');
      this.meta.removeTag('twitter:image');
    } catch (error) {

    }
    this.titleService.setTitle(title)
    this.meta.addTag({ name: 'title', content: title });
  }
}
